import { useState } from 'react';

import AddArtworks from '@/pages/profile/artlist/artlist-body/options/add-artworks/generic/index';
import { getArtworkArtistDisplayName } from '@/utils/artworkArtists';

import './ArtworkManager.css';
import '@/shared-components/forms/add-board-content/board-text-body/add-element/add-picture/BoardBodyPicture.css';

export default function ArtworkManager({
  open,
  close,
  dispatch,
  maxArtworks,
}) {
  const [selectedArtworks, setSelectedArtwors] = useState([]);
  const MAX_ARTWORKS = maxArtworks;

  function handleModalClose() {
    if(selectedArtworks.length) {
      // slug imageUrl caption artworkId
      const groupedArtworks = selectedArtworks.map(artwork => {
        const resolvedArtist = getArtworkArtistDisplayName(artwork);
        const artistName = resolvedArtist === "-" ? "" : resolvedArtist;
        const artworkTitle = artwork.artwork_about?.artwork_title || "";
        return {
          slug: artwork.slug,
          imageUrl: artwork.artwork_media.artwork_main_picture.image_id,
          caption: artistName
            ? `${artworkTitle} by ${artistName}`
            : `${artworkTitle} by Unknown Artist`,
          artworkId: artwork._id,
          artistName,
          artworkTitle,
        };
      });

      dispatch({
        type: 'BLOCK_CREATED',
        blockType: 'post_artworks',
        data: { artworks: groupedArtworks },
      });
    }
    close();
    setSelectedArtwors([]);
  }

  return (
    <div className="add-board-artwork-container">
      <AddArtworks
        open={open}
        close={handleModalClose}
        selectedArtworks={selectedArtworks}
        setSelectedArtworks={setSelectedArtwors}
        maxSelectedArtworks={MAX_ARTWORKS}
      />
    </div>
  );
}
